<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('listeConstatationCharge.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <selecteur-action
            class="column is-narrow"
            @handleAction="handleAction"
            :elementsSelectionnes="hasSomeConstationSelected"
            :titleButton="'general.button.apply'"
            :options='actions'
            :placeholder='$t("general.placeHolder.groupedAction")'>
          </selecteur-action>
          <p class="column is-narrow mgt-5px">
            {{ $t('listeConstatationCharge.datePivot') }}
          </p>
          <b-datepicker show-week-number class="column is-narrow"
                        @input="recherche()"
                        v-model="criteresRecherche.datePivotConstatationChargeContrat"
                        icon="calendar-today"
                        nearby-selectable-month-days
                        :editable="true">
          </b-datepicker>
          <div class="column is-narrow">
            <button class="button" @click='showFiltreAndLockMenu()'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('general.button.filtre')}}
                <label class="has-text-weight-bold"
                        :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading"
      v-if="startArrayRendering">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <template slot="selected" slot-scope="{ row }">
        <div class="has-check-centered has-text-centered">
          <b-checkbox v-if="row.selected !== undefined"
                      v-model="row.selected">
          </b-checkbox>
        </div>
      </template>
      <div slot="codeDossier" slot-scope="props">
        <router-link-blank
          :to="{ name: 'c.baux.contrat', params: { id: props.row.referenceExterne }}"
          class="lien"
          :message="props.row.codeDossier">
        </router-link-blank>
      </div>
      <div slot="dateDevisCommande" slot-scope="props">
        {{ props.row.dateDevisCommande | formatDate }}
      </div>
      <div slot="datePremierAffichage" slot-scope="props">
        {{ props.row.datePremierAffichage | formatDate }}
      </div>
      <div slot="dateValidite" slot-scope="props">
        {{ props.row.dateValidite | formatDate }}
      </div>
      <div slot="montantTtc" slot-scope="props" class="is-pulled-right">
        {{ props.row.montantTtc | formatDevise }}
      </div>
      <div slot="montantHt" slot-scope="props" class="is-pulled-right">
        {{ props.row.montantHt | formatDevise }}
      </div>
      <div slot="montantRestantAConstaterHt" slot-scope="props" class="is-pulled-right">
        {{ calculeResteAConstater(props.row) | formatDevise }}
      </div>
      <div slot="bailleur" slot-scope="props">
        {{ props.row.intervenants[0].nomCommercial }}
      </div>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10">
      <div class="componentBrief" v-if="showFiltre === true">
        <filtre-constatation-charge
            @toggleFiltre="showFiltre = false"
            @recherche="recherche"/>
      </div>
    </transition>
    <b-modal
      v-model="popupConstation"
      width="500px"
      @close="closePopUpConstatation">
      <popUpPrevention
          :messHeader="$t('listeConstatationCharge.titlePopupConstatation')"
          :cancel="this.$t('general.non')"
          :validate="this.$t('general.oui')"
          :messagesPopup="messages"
          :messagesChampsVide="messagesChampsVide"
          :champsVide="champsVide"
          :isErrorPopup.sync="error"
          :questions="questionAvertissement"
          @validateQuestions="lancerGenerationCharge"
          @no="closePopUpConstatation" >
      </popUpPrevention>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import breadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import { CONSTATATION_CHARGE } from '@/configuration/baux/permissionsBauxConf';
import selecteurAction from '@/components/general/selecteurAction';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import subscribeMutation from '@/services/store/subscribeMutation';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { SET_CRITERE_RECHERCHE, RESET_CRITERE_RECHERCHE } from '@/store/modules/baux/constatationCharge-mutation-type';
import formatIsoDate from '@/services/general/formatIsoDate';
import { ETAT_ENREGISTRE, ETAT_FACTURE_PARTIELLEMENT } from '@/configuration/devisConf';
import { TYPE_CONTRAT, ACTION_CONSTATION_CHARGE } from '@/configuration/baux/contrat/contratConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { generationCharge } from '@/api/factureAchat';
import messageSucces from '@/services/general/messageSucces';
import validationConstatationCharge from '@/services/baux/constatationCharge/validationConstatationCharge';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_CONSTATATION_CHARGE } from '@/configuration/general/referenceTableConf';
import filtreConstatationCharge from '@/components/baux/constationCharge/filtreConstatationCharge';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/baux/contrat/translatorContrat';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import checkPeriodeAndFormat from '@/services/dcf/checkPeriodeAndFormat';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import popUpPrevention from '@/components/general/popUpPrevention';

const Permissions = createNamespacedHelpers('permissions');
const ConstatationCharge = createNamespacedHelpers('constatationCharge');
const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      loadingComponent: null,
      unsubscribeValue: null,
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      questionAvertissement: [{
        key: 0,
        message: 'listeConstatationCharge.dateComptable',
        value: null,
        type: 'date',
      }],
      error: false,
      idsLignesError: [],
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_CONSTATATION_CHARGE,
      resultPerPage: RESULTS_PER_PAGE,
      actions: [{ action: ACTION_CONSTATION_CHARGE, translation: 'listeConstatationCharge.actions.constatationCharge' }],

      popupConstation: false,
      showFiltre: false,
    };
  },
  components: {
    breadcrumb,
    TableItemsInView,
    routerLinkBlank,
    parametrageTable,
    selecteurAction,
    filtreConstatationCharge,
    popUpPrevention,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...ConstatationCharge.mapGetters({
      criteresRecherche: 'criteresRecherche',
      constatationCharge: 'items',
      totalCount: 'total',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    breadcrumb() {
      return [
        { title: this.$t('listeConstatationCharge.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeConstatationCharge.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
    hasSomeConstationSelected() {
      return this.constatationCharge.some(c => c.selected);
    },
    allConstatationChargeSelected() {
      return this.constatationCharge.length !== 0 && this.constatationCharge.every(c => c.selected);
    },
    iconSelectTotal() {
      if (this.allConstatationChargeSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          datePremierAffichage: this.$i18n.t('listeConstatationCharge.tab.echeance'),
          codeDossier: this.$i18n.t('listeConstatationCharge.tab.code'),
          dateDevisCommande: this.$i18n.t('listeConstatationCharge.tab.dateDebut'),
          dateValidite: this.$i18n.t('listeConstatationCharge.tab.dateFin'),
          bailleur: this.$i18n.t('listeConstatationCharge.tab.bailleur'),
          montantTtc: this.$i18n.t('listeConstatationCharge.tab.montantTtc'),
          montantHt: this.$i18n.t('listeConstatationCharge.tab.montantHt'),
          montantRestantAConstaterHt: this.$i18n.t('listeConstatationCharge.tab.montantRestantAConstaterHt'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          data.query.agencesId = this.agencesSelectionnees.map(agence => agence.agenceId);
          data.query.etat = [ETAT_ENREGISTRE, ETAT_FACTURE_PARTIELLEMENT];
          data.query.aRapprocher = false;
          data.query.typeReferenceExterne = TYPE_CONTRAT;
          data.query.montantDifferentZero = true;
          data.query.datePivotConstatationChargeContrat = formatIsoDate(
            data.query.datePivotConstatationChargeContrat,
          );
          checkPeriodeAndFormat(data.query, 'datesPremierAffichage');
          checkPeriodeAndFormat(data.query, 'dates');
          checkPeriodeAndFormat(data.query, 'datesValidite');
          data.query.tiersId = tagInputToArray(data.query.tiersId, 'id') ?? [];

          return this.loadConstatationCharge(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.constatationCharge,
            count: this.totalCount,
          };
        }),
        sortable: ['codeDossier', 'dateDevisCommande', 'dateValidite', 'montantTtc', 'montantHt', 'datePremierAffichage'],
        columnsClasses: {
          selected: 'colonneSelected has-text-centered',
        },
        rowClassCallback: ((row) => {
          return this.idsLignesError.find((id) => { return id === row.id; })
            ? 'background-error-table' : '';
        }),
      };
    },
    columns() {
      return ['selected', 'datePremierAffichage', 'codeDossier', 'dateDevisCommande', 'dateValidite', 'bailleur', 'montantHt', 'montantTtc', 'montantRestantAConstaterHt'];
    },
    nombreCritere() {
      const banCritereKey = ['etat', 'datesPremierAffichage', 'dates', 'datesValidite', 'datePivotConstatationChargeContrat'];
      let nombreCritere = calculNombreCritere(this.criteresRecherche, banCritereKey);
      if (!!this.criteresRecherche.datesPremierAffichage?.dateDebut
      || !!this.criteresRecherche.datesPremierAffichage?.dateFin) nombreCritere += 1;
      if (this.criteresRecherche.dates.dateDebut
      || this.criteresRecherche.dates.dateFin) nombreCritere += 1;
      if (this.criteresRecherche.datesValidite.dateDebut
      || this.criteresRecherche.datesValidite.dateFin) nombreCritere += 1;
      if (nombreCritere > 9) return '9+';
      return nombreCritere;
    },
  },
  methods: {
    ...ConstatationCharge.mapActions({
      loadConstatationCharge: 'loadConstatationCharge',
    }),
    ...ConstatationCharge.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
      resetCritereRecherche: RESET_CRITERE_RECHERCHE,
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    closePopUpConstatation() {
      this.popupConstation = false;
      this.messages = [];
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.error = false;
    },
    finLoading() {
      this.loadingComponent.close();
    },
    reinitialiserFiltre() {
      this.resetCritereRecherche();
      this.recherche();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    selectAll() {
      const select = !this.allConstatationChargeSelected;
      this.constatationCharge.forEach((el) => {
        if (el.selected !== undefined) this.$set(el, 'selected', select);
      });
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    showFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      this.setLockMenu(this.showFiltre);
    },
    calculeResteAConstater(commande) {
      let montant = 0;
      commande.echeanciers.forEach(e => {
        montant += e.echeancierLignes
          .filter(l => !l.facturationFaite)
          .map(l => l.montant)
          .reduce((a, b) => a + b, 0);
      });
      return montant;
    },
    handleAction(action) {
      switch (action) {
        case ACTION_CONSTATION_CHARGE:
          if (this.checkPermissions(CONSTATATION_CHARGE.maj)) {
            this.questionAvertissement[0]
              .value = this.criteresRecherche.datePivotConstatationChargeContrat;
            this.popupConstation = true;
          } else {
            this.showPopUp();
          }
          break;
        default:
          break;
      }
    },
    async lancerGenerationCharge(valeurs) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        this.idsLignesError = [];
        const params = {
          societeId: this.societeActiveId,
          commandesAchatIds: this.constatationCharge
            .filter(c => c.selected)
            .map(c => c.id),
          agencesId: this.agencesSelectionnees.map(agence => agence.agenceId),
          dateComptable: formatIsoDate(valeurs[0].value),
        };
        await generationCharge(params);
        messageSucces(this.$i18n.t('listeConstatationCharge.messages.success.generation'));
        this.closePopUpConstatation();
        loadingComponent.close();
        this.recherche();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validationConstatationCharge(e.response, this.messages,
            this.idsLignesError, this.constatationCharge);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageBaux.constatationCharge.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
